module.exports = __webpack_public_path__ + "media/images/icon__info--white-1eaaaa4b586932e373fac885be78df2a.png";